import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { requiresAuth: false }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/SignUp.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/landing',
      name: 'landing',
      component: () => import('./views/Landing.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/tracks',
      name: 'tracks',
      component: () => import('./views/TrackSelection.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/search/:q',
      name: 'search',
      component: () => import('./views/Search.vue'),
      meta: { requiresAuth: true },
      props: (route) => ({q: route.params.q})
    },
    {
      path: '/playlist/:id',
      name: 'playlist',
      component: () => import('./views/Playlist.vue'),
      meta: { requiresAuth: true },
      props: (route) => ({id: route.params.id})
    },
    {
      path: '/my-tracks',
      name: 'myTracks',
      component: () => import('./views/MyTracks.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/persona-start',
      name: 'personaStart',
      component: () => import('./views/PersonaStart.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/persona-photo',
      name: 'personaPhoto',
      component: () => import('./views/PersonaPhoto.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: () => import('./views/Confirmation.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/choon',
      name: 'choon',
      component: () => import('./views/Choon.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/set',
      name: 'set',
      component: () => import('./views/Booking.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/share',
      name: 'share',
      component: () => import('./views/ShareSet.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('./views/admin/Admin.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/requests',
      name: 'requests',
      component: () => import('./views/admin/Requests.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/tracks',
      name: 'adminTracks',
      component: () => import('./views/admin/Tracks.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/playlists',
      name: 'playlists',
      component: () => import('./views/admin/Playlists.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: '/admin/signage',
      name: 'signage',
      component: () => import('./views/admin/Signage.vue'),
      meta: { requiresAuth: true, requiresAdmin: true }
    },
  ]
})
